import styles from './styles/loginPage.module.scss';

import LeftBand from '../features/auth/components/login/leftBand/LeftBand';
import LoginActionTitle from '../features/auth/components/login/loginActionTitle/LoginActionTitle';
import SignChoiceButton from '../features/auth/components/login/loginChoiceButton/LoginChoiceButton';
import LoginContent from '../features/auth/components/login/loginContent/LoginContent';

function LoginPage() {
  return (
    <div className={styles.sign}>
      <LeftBand />

      <main className={styles.content}>
        <LoginActionTitle className={styles.actionTitle} />

        <SignChoiceButton className={styles.actionButton} />

        <LoginContent className={styles.signIn} />
      </main>
    </div>
  );
}

export default LoginPage;
